export const PERMISSIONS = {
  PAGE: 'page:userprofile',
  ACTIONS: {
    VIEW_INFO_TAB: 'action:viewUserInfoTab',
    VIEW_BUNDLE_TAB: 'action:viewUserBundleTab',
    VIEW_PAYMENTS_TAB: 'action:viewUserPaymentsTab',
    VIEW_TRANSACTIONS_TAB: 'action:viewUserTransactionsTab',
    VIEW_COMMUNICATIONS_TAB: 'action:viewUserCommunicationsTab',
    VIEW_DOCUMENTS_TAB: 'action:viewUserDocumentsTab',
    CHANGE_NUMBER: 'action:changeUserNumber',
    DEACTIVATE_ACCOUNT: 'action:deactivateUserAccount',
    BLOCK_ACCOUNT: 'action:blockUserAccount',
    CHANGE_TYPE: 'action:changeUserType',
    VIEW_ADDRESS_BOOK: 'action:viewAddressBook',
    VIEW_CONTACTS: 'action:viewUserContacts',
    VIEW_AGREEMENT_CONTRACT: 'action:viewUserAgreementContract',
    RESET_INSURANCE_NOTE: 'action:resetUserInsuranceNote',
    REQUEST_FINANCIAL_CLEARNESS: 'action:requestFinancialClearness',
    UPLOAD_DOCUMENTS: 'action:uploadUserDocuments',
    SPLIT_PAYMENTS: 'action:splitPayments',
    REMOVE_PAYMENT: 'action:removePayment',
    EDIT_PAYOUT_METHOD: 'action:editDefaultPayoutMethod',
    SET_APPOINTMENTS: 'action:setAppointments',
    REMOVE_FROM_CIRCLE: 'action:removeFromCircle',
    REQUEST_EARLY_PAYOUT: 'action:requestEarlyPayout',
    END_CIRCLE: 'action:endCircle',
    ADD_LEAVE_REQUEST: 'action:addUserLeaveRequest',
    ADD_TO_CIRCLE: 'action:addUserToCircle',
    ADD_TO_SAME_CIRCLE: 'action:addUserToSameCircle',
    SEND_SMS_PUSH: 'action:sendSms/Push',
    VIEW_TYPE_LOG: 'action:viewUserTypeLog',
    VIEW_CHANGE_NUMBER_HISTORY: 'action:viewUserChangeNumberHistory',
    VIEW_FINANCIAL_CLEARNESS_LOG: 'action:viewUserFinancialClearnessLog',
    VIEW_CONTRACT_DOCUMENTS: 'action:viewUserContractDocuments',
    VIEW_INSURANCE_NOTE_DOCUMENTS: 'action:viewUserInsuranceNoteDocuments',
    VIEW_WARNING_LETTER_DOCUMENTS: 'action:viewUserWarningLetterDocuments',
    VIEW_LEGAL_CASES_DOCUMENTS: 'action:viewUserLegalCasesDocuments',
    VIEW_DFP_LOG: 'action:viewUserDFPLog',
    VIEW_PAY_IN_ADVANCE_LOG: 'action:viewUserPayInAdvanceLog',
    VIEW_PAYOUT_BREAKDOWN_LOG: 'action:viewUserPayoutBreakdownLog',
    VIEW_PAYOUT_TRANSACTIONS_LOG: 'action:viewUserPayoutTransactionsLog',
    VIEW_PAYOUT_HISTORY_TIMELINE: 'action:viewUserPayoutHistoryTimeline',
    VIEW_PENALTIES_HISTORY: 'action:viewUserPenaltiesHistory',
    VIEW_SPLIT_HISTORY: 'action:viewUserSplitHistory',
    VIEW_APPOINTMENT_HISTORY: 'action:viewUserAppointmentHistory',
    VIEW_PROMO_CODE_HISTORY: 'action:viewUserPromoCodeHistory',
    VIEW_ELIGIBLE_PROMO_CODE_HISTORY: 'action:viewUserEligiblePromoCodeHistory',
    ADD_COMMUNICATION: 'action:addUserProfileCommunication',
    CREATE_PAYIN_OVERRIDE: 'action:createPayinOverrideBtn',
    REMOVE_PAYIN_OVERRIDE: 'action:payinOverrideRemove',
    VIEW_PAYIN_OVERRIDES: 'action:payinOverrideView',
    CANCEL_LEAVE_REQUEST: 'action:cancelLeaveRequest',
    VIEW_MFCARD_TAB: 'action:viewUserCard',
    INVITE_USER_FOR_CARD: 'action:inviteCardUser',
    ADD_USER_REFERRAL: 'action:addUserReferral',
    RESET_PAYOUT_METHOD: 'action:resetUserPayment',
    APPLY_PROMOTION_TO_BUNDLE: 'action:applyPromotionToBundle',
    VIEW_BUNDLE_PROMOTION: 'action:viewBundlePromotion',
    SEND_PAYMENT_LINK: 'action:sendPaymentLink',
    CHANGE_BUNDLE_DETAILS: 'action:changeBundleDetails',
    CAN_REPLACE_USERS: 'action:canReplaceUsers',
    CAN_JOIN_NORMAL_STARTED: 'action:canJoinNormalStarted',
    VIEW_SERVICE_REQUESTS_TAB: 'action:viewMoneyfellowsServicesUserRequests',
    CREATE_SERVICE_REQUEST: 'action:addMoneyfellowsServicesUserRequests',
    VIEW_USER_TAGS: 'action:viewUserTags',
    ADD_USER_TO_WATCHLIST: 'action:addUserToWatchlist',
    VIEW_USER_WATCHLIST: 'action:viewUserWatchlist',
  },
};
